import React from 'react'
import { WidgetContent } from '@duik/it'
import { ModalButton } from '../UI/ModalButton'
import CreateNewModal from '../UI/CreateNewModal'
import FormInputGroup from '../UI/FormInputGroup'
import { Formik, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DatePicker from 'react-datepicker'

const SignOnOffMultiModal = props => {
  const handleEditTime = (signOnTime, signOffTime) => {
    props.handleEditTime(signOnTime, signOffTime)
    props.handleClose()
  }

  return (
    <CreateNewModal title="Sign On / Off" handleCloseModal={props.handleClose}>
      <Formik
        initialValues={{
          signOnTime:
            props.editDetail.signOnTime.length > 0 ? new Date(props.editDetail.signOnTime) : '',
          signOffTime:
            props.editDetail.signOffTime.length > 0 ? new Date(props.editDetail.signOffTime) : ''
        }}
        validationSchema={ContactSchema}
        handleSubmit={e => console.log('')}
        onSubmit={values => {
          const { signOnTime, signOffTime } = values
          handleEditTime(signOnTime, signOffTime)
        }}
        render={({
          values,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue
        }) => (
          <form onSubmit={handleSubmit}>
            <WidgetContent style={{ height: '387px' }}>
              <p style={{ margin: '0 0 25px 0' }}>Update one of the times below</p>
              <FormInputGroup vertical>
                <div>
                  <span className="uik-content-title__wrapper">Sign On</span>
                  <div>
                    <DatePicker
                      selectsStart
                      className="uik-input__input fullWidthInputBox"
                      name="signOnTime"
                      selected={values.signOnTime}
                      onChange={e => setFieldValue('signOnTime', e)}
                      // value={values.signOnTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="HH:mm"
                      timeCaption="Time"
                      onBlur={handleBlur}
                      autoComplete="off"
                    />
                    <ErrorMessage
                      name="signOnTime"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </div>
                <div>
                  <span className="uik-content-title__wrapper">Sign Off</span>
                  <div>
                    <DatePicker
                      selectsEnd
                      className="uik-input__input fullWidthInputBox"
                      onBlur={handleBlur}
                      name="signOffTime"
                      selected={values.signOffTime}
                      onChange={e => setFieldValue('signOffTime', e)}
                      // value={values.signOffTime}
                      showTimeSelect
                      showTimeSelectOnly
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="HH:mm"
                      minDate={values.signOnTime}
                      autoComplete="off"
                    />
                    <ErrorMessage
                      name="signOffTime"
                      render={msg => (
                        <span
                          style={{
                            position: 'absolute',
                            color: '#E6492D',
                            fontSize: '0.75rem'
                          }}
                        >
                          {msg}
                        </span>
                      )}
                    />
                  </div>
                </div>
              </FormInputGroup>
            </WidgetContent>
            <WidgetContent style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ width: '83px' }}>
                <ModalButton buttonStyle="tertiary" name="Cancel" onClick={props.handleClose} />
              </div>
              <div style={{ width: '83px' }}>
                <ModalButton
                  buttonStyle="primary"
                  success
                  type="submit"
                  disabled={isSubmitting}
                  name="Save"
                />
              </div>
            </WidgetContent>
          </form>
        )}
      />
    </CreateNewModal>
  )
}

export default SignOnOffMultiModal

const ContactSchema = Yup.object().shape({})
